import { Folder, FolderTypeNameData, Subfolder, SubfolderTypeNameData } from 'modules/domains';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { List, ListsGraphQLQueryVariables } from 'modules/domains/list';

export type ListSubfolderTypeNameData = SubfolderTypeNameData<GRAPHQL_TYPENAMES.LIST_SUBFOLDER>;
export type ListFolderTypeNameData = FolderTypeNameData<GRAPHQL_TYPENAMES.LIST_FOLDER>;

export type ListSubfolder = Subfolder<GRAPHQL_TYPENAMES.LIST_SUBFOLDER>;
export type ListFolder = Folder<
  List,
  GRAPHQL_TYPENAMES.LIST_FOLDER,
  GRAPHQL_TYPENAMES.LIST_SUBFOLDER
>;

export enum ContentFilter {
  ContentItem = 'ContentItem',
  Subfolder = 'Subfolder',
}
export type ListFoldersGraphQLQueryVariables = ListsGraphQLQueryVariables & {
  content?: ContentFilter;
  recursive?: boolean;
};

export type ListFoldersGraphQLQueryResponse = {
  listFolder: ListFolder | null;
};
